
import Vue, { PropType } from 'vue';
import { mapActions, mapState } from 'pinia';
import { useStore as useProductStore } from '@/stores/v2/product';
import { useStore as useShapeStore } from '@/stores/v2/shape';
import { useStore as useMirrorStore } from '@/stores/v2/mirror';
import VModal from 'vue-js-modal';
import Checkmark from '@carbon/icons-vue/es/checkmark/16';
import { ProductColorSetterType } from '@/setters/typings/common/ProductColorsSetterType';
import { ProductPrintVariant } from '@midocean/webapps-shared-domain';
import { CvAccordion, CvAccordionItem } from '@carbon/vue';

Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
});

export default Vue.extend({
  name: 'SwitchColor',
  components: {
    Checkmark,
    CvAccordion,
    CvAccordionItem,
  },

  props: {
    productVariants: {
      type: [] as PropType<ProductColorSetterType[]>,
      required: true,
    },
  },

  computed: {
    ...mapState(useProductStore, [
      'data',
      'isLaserConverter',
      'isDebossingTechnique',
      'isSublimationTechnique',

      'getDebossingColor',
      'selectedVariant',
    ]),

    productName(): string {
      if (this.selectedVariant) {
        return this.selectedVariant.name;
      } else {
        return '';
      }
    },

    hideSelectedColors(): boolean {
      return (
        process.env.VUE_APP_AS_A_SERVICE === 'true' &&
        this.productVariants.length <= 1
      );
    },
  },

  methods: {
    ...mapActions(useProductStore, ['setSelectedVariant', 'isConverterUsed']),
    ...mapActions(useShapeStore, ['reinitializeShapeVariantImage']),
    ...mapActions(useMirrorStore, ['reinitializeMirrorShapeVariantImage']),

    changeProductVariantImg(variant: ProductColorSetterType) {
      let selectedVariantFound = this.data.variants.find(
        (varImg) => varImg.colour == variant.variantColor
      ) as ProductPrintVariant;

      this.setSelectedVariant(selectedVariantFound);

      if (this.isConverterUsed()) {
        let textColor = [255, 255, 255];
        if (this.isDebossingTechnique()) {
          textColor = this.getDebossingColor;
        }
        this.reinitializeShapeVariantImage(selectedVariantFound, textColor);
        this.reinitializeMirrorShapeVariantImage(
          selectedVariantFound,
          textColor
        );
      }
    },
  },
});
